import { outerSpaceUltraDark, outerSpaceLight } from './color'

export const boxShadowLevelOne = `0 1px 2px ${outerSpaceLight}`
export const boxShadowLevelTwo = `0 1px 4px ${outerSpaceUltraDark}`
